import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import { IUser } from '@reverbdotcom/commons/src/components/user_context_provider';
import {
  core_apimessages_CheckoutPaymentMethod_Type as CheckoutPaymentMethodType,
} from '../schemas/rql';
import experiments from '@reverbdotcom/commons/src/experiments';

export const PAYMENT_METHOD_TO_ROLLOUT_NAME: { [type in CheckoutPaymentMethodType]?: string } = {
  [CheckoutPaymentMethodType.AFFIRM]: experiments.AFFIRM_SINGLE_PAGE_CHECKOUT,
};

export const SINGLE_PAGE_CHECKOUT_PAYMENT_METHODS = [
  CheckoutPaymentMethodType.KLARNA_ACCOUNT,
  CheckoutPaymentMethodType.SOFORT,
];

export function showGuestAuthModal(user: Partial<IUser>, paymentMethodType: CheckoutPaymentMethodType) {
  const isAlwaysSinglePageCheckout = SINGLE_PAGE_CHECKOUT_PAYMENT_METHODS.includes(paymentMethodType);
  const experimentName = PAYMENT_METHOD_TO_ROLLOUT_NAME[paymentMethodType];
  const isSinglePageCheckoutExperiment = !!experimentName && isExperimentEnabled(user, experimentName);

  return user.loggedOut &&
    (isAlwaysSinglePageCheckout || isSinglePageCheckoutExperiment);
}

export function guestCheckoutExperiments(user: Partial<IUser>, paymentMethod: string) {
  if (user.loggedOut && paymentMethod.toUpperCase() === CheckoutPaymentMethodType.DIRECT_CHECKOUT) {
    return [experiments.SINGLE_PAGE_GUEST_CHECKOUT_V3];
  }

  return [];
}
